import { parseInlineCitationList } from "@hightouch/lib/llm/inline-citation-tags";
import { useInlineCitationsContext } from "./inline-citations-context";
import { CitationsPill } from "./citations-pill";
import { resolveParagraphCitedEntries } from "./derive-session-context";

type Props = {
  assumptions?: string;
  referenced?: string;
  versions?: string;
};

export const InlineCitations = ({
  assumptions,
  referenced,
  versions,
}: Props) => {
  const citationsContext = useInlineCitationsContext();
  if (!citationsContext) return null;

  const { citationGroupId, citationGroup, resolveLookedUpCitations, setView } =
    citationsContext;
  const refs = {
    assumptionKeys: parseInlineCitationList(assumptions),
    referencedIds: parseInlineCitationList(referenced),
    versionIds: parseInlineCitationList(versions),
  };
  const citedEntries = resolveParagraphCitedEntries(citationGroup, refs);
  const citations =
    citedEntries.length > 0 ? resolveLookedUpCitations(citedEntries) : null;
  if (!citations) return null;

  return (
    <CitationsPill
      variant="inline"
      citations={citations}
      onClick={() => setView({ kind: "paragraph", citationGroupId, ...refs })}
      onSelectCitation={(citation) =>
        setView({
          kind: "paragraph",
          citationGroupId,
          ...refs,
          focusedCitedEntry: citation.citedEntry,
        })
      }
    />
  );
};
